module.exports = __webpack_public_path__ + "img/isbar4.eba89271.png";